//      
import {              } from 'css-box-model';
import isWithin from '../is-within';

export default (frame         ) => {
  const isWithinVertical = isWithin(frame.top, frame.bottom);
  const isWithinHorizontal = isWithin(frame.left, frame.right);

  return (subject         ) => {
    const isContained          =
      isWithinVertical(subject.top) &&
      isWithinVertical(subject.bottom) &&
      isWithinHorizontal(subject.left) &&
      isWithinHorizontal(subject.right);

    return isContained;
  };
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/visibility/is-totally-visible-through-frame.js